export default __webpack_public_path__ + "4b81a24.png";